var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "File",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-321.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-9",
    transform: "translate(33.000000, 455.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(321.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5435696,23.6347846 C20.5435696,24.9145378 19.5143323,25.9519044 18.2446988,25.9519044 L2.43987467,25.9519044 C1.17024118,25.9519044 0.141003935,24.9144872 0.141003935,23.6347846 L0.141003935,2.31711984 C0.141003935,1.03741724 1.17024118,0 2.43987467,0 L12.2789069,0 C12.7368141,0 13.1759513,0.183589449 13.4993571,0.51031987 L20.0398917,7.11690428 C20.3624443,7.44267164 20.5435696,7.88415814 20.5435696,8.34439895 L20.5435696,23.6347846 Z",
    id: "Path",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99070654,25.9519044 L2.43967393,25.9519044 C1.17039174,25.9519044 0.141003935,24.9143351 0.141003935,23.6345311 L0.141003935,2.31737328 C0.141003935,1.0375693 1.17039174,0 2.43967393,0 L3.99070654,0 C2.72142436,0 1.69203655,1.0375693 1.69203655,2.31737328 L1.69203655,23.6344804 C1.69203655,24.9143351 2.72142436,25.9519044 3.99070654,25.9519044 Z",
    id: "Path",
    fill: "#CED0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5435696,8.34429757 L20.5435696,9.19229632 L14.5482175,9.19229632 C12.8358333,9.19229632 11.4429904,7.78506444 11.4429904,6.05561332 L11.4429904,0 L12.2790073,0 C12.7365632,0 13.1760517,0.183792198 13.4991563,0.510167808 L20.0399419,7.11670153 C20.3625949,7.44251958 20.5435696,7.88425952 20.5435696,8.34429757 L20.5435696,8.34429757 Z",
    id: "Path",
    fill: "#CED0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3889933,7.62580491 L14.5482175,7.62580491 C13.6899677,7.62580491 12.9940732,6.92297462 12.9940732,6.05561332 L12.9940732,0.157181358 C13.1807191,0.242285357 13.3518571,0.361349856 13.4992065,0.510167808 L20.0399921,7.11670153 C20.1873415,7.2654688 20.3047291,7.43780566 20.3889933,7.62580491 Z",
    id: "Path",
    fill: "#656969"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "file.69e0296055732dab720088573e756aec.svg";